/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrokerAbpInfos
 */
export interface BrokerAbpInfos {
    /**
     * ABP user identifier
     * @type {string}
     * @memberof BrokerAbpInfos
     */
    abpUserId: string;
    /**
     * First name (prénom)
     * @type {string}
     * @memberof BrokerAbpInfos
     */
    firstName: string;
    /**
     * Last name (nom)
     * @type {string}
     * @memberof BrokerAbpInfos
     */
    lastName: string;
    /**
     * User email address
     * @type {string}
     * @memberof BrokerAbpInfos
     */
    email: string;
    /**
     * List of plateforme identifiers
     * @type {Array<string>}
     * @memberof BrokerAbpInfos
     */
    plateformeIds: Array<string>;
    /**
     * List of role identifiers
     * @type {Array<string>}
     * @memberof BrokerAbpInfos
     */
    roleIds: Array<string>;
    /**
     * Date of last connection if available
     * @type {Date}
     * @memberof BrokerAbpInfos
     */
    lastConnectionDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof BrokerAbpInfos
     */
    creationDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof BrokerAbpInfos
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the BrokerAbpInfos interface.
 */
export function instanceOfBrokerAbpInfos(value: object): value is BrokerAbpInfos {
    if (!('abpUserId' in value) || value['abpUserId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('plateformeIds' in value) || value['plateformeIds'] === undefined) return false;
    if (!('roleIds' in value) || value['roleIds'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function BrokerAbpInfosFromJSON(json: any): BrokerAbpInfos {
    return BrokerAbpInfosFromJSONTyped(json, false);
}

export function BrokerAbpInfosFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerAbpInfos {
    if (json == null) {
        return json;
    }
    return {
        
        'abpUserId': json['abpUserId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'plateformeIds': json['plateformeIds'],
        'roleIds': json['roleIds'],
        'lastConnectionDate': json['lastConnectionDate'] == null ? undefined : (new Date(json['lastConnectionDate'])),
        'creationDate': (new Date(json['creationDate'])),
        'isActive': json['isActive'],
    };
}

export function BrokerAbpInfosToJSON(json: any): BrokerAbpInfos {
    return BrokerAbpInfosToJSONTyped(json, false);
}

export function BrokerAbpInfosToJSONTyped(value?: BrokerAbpInfos | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'abpUserId': value['abpUserId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'plateformeIds': value['plateformeIds'],
        'roleIds': value['roleIds'],
        'lastConnectionDate': value['lastConnectionDate'] == null ? undefined : ((value['lastConnectionDate'] as any).toISOString()),
        'creationDate': ((value['creationDate']).toISOString()),
        'isActive': value['isActive'],
    };
}

